export default __webpack_public_path__ + "static/FacebookButton-00031df450773c93e93ba1eb15ae9ad8.svg";